export default "__VITE_ASSET__TXpxQqXd__"